import { cloneDeep, sortBy, filter as filterArray, findIndex, remove, uniq, uniqBy, flatMap } from "lodash";
import { isPopulatedArray, isValidString } from "./funcs";
import { User } from "../../modules/core/users";

interface Assignee {
  id: number;
  name: string;
}

interface ItemWithAssignedTo {
  assignedTo?: User[];
}


const getAssignees = (list: ItemWithAssignedTo[] | undefined | null): Assignee[] => {
  if (!isPopulatedArray(list)) {
    return [];
  }

  const allUsers = flatMap(list, (item) => item.assignedTo ?? [])
    .filter((user): user is User => Boolean(user?.id && user?.name))
    .map((user) => ({ id: user.id as number, name: user.name }));

  return sortBy(uniqBy(allUsers, 'id'), 'name');
};

type searchFilterProps = {
  list: Array<any>
  search: string | undefined,
  filter: any,
  excludeDraft?: boolean
}


const checkForSearchMatch = (dat: Object, patt: RegExp) => {
  let _found = false;
  Object.keys(dat).forEach(key => {
    // @ts-ignore
    if ((typeof dat[key] === 'string' || typeof dat[key] === 'number') && patt.test(`${dat[key]}`)) {
      _found = true;            
    }
  })
  
  return _found;
}

const applyFormSearchFilter = ({ list, search, filter, excludeDraft } : searchFilterProps) => {

  if (! (isPopulatedArray(list))) {
    return [];
  }

  let _lines = filterArray(list, o => (! o?.deleted));

  if (excludeDraft) {
    _lines = filterArray(_lines, (o:any) => { return (o?.state === 'Draft' ? false : true); });
  }

  if (filter && typeof filter === 'object') {
    let _filter_obj = {};
    let _assignedTo = 0;
    let _selectedState = '';

    Object.keys(filter).forEach(key => {
      if (! filter[key]) {
        return;
      }
      let val = filter[key];
      switch(key) {
        case 'assignedTo': 
          _assignedTo = val;  
          break;
        case 'state': 
          _selectedState = val;
          break;
        default:
          Object.assign(_filter_obj, { [key] : val});     
          break;
      }        
    })

    if (Object.keys(_filter_obj).length > 0) {
      _lines = filterArray(_lines, _filter_obj);
    }
    if (_assignedTo) {
      _lines = filterArray(_lines, (item: any) => ((
        item && (
          (item?.assignedTo && findIndex(item.assignedTo, { id: parseInt(`${_assignedTo}`)}) > -1)
          || 
          ((! isPopulatedArray(item?.assignedTo)) && item?.assignedBy && findIndex(item.assignedBy, { id: parseInt(`${_assignedTo}`)}) > -1)
        )
        
      ) ? true : false));
    }

    // filter states
    if (isValidString(_selectedState)) {
      // find items with 
      let _ids = uniq(_lines.reduce((list: any, item) => {
        // include application state
        if (item.state === _selectedState) {
          list.push(item.id);
          return list;
        }
        // iterate over site states
        if (! (item?.siteApplications && isPopulatedArray(item.siteApplications))) {
          return list;
        }
        for (const site of item.siteApplications) {
          if (site?.state && isValidString(site?.state) && site.state === _selectedState) {
            list.push(item.id);
            break;
          }
        }
        return list;          
      }, []));
    
      // filter array with selected ids
      _lines = filterArray(_lines, (o: any) => (_ids.includes(o.id)));
    }
  }
  

  // apply search
  if (search && isValidString(search)) {
    try {
      const patt  = new RegExp(search, 'i');
      remove(_lines, (dat) => !checkForSearchMatch(dat, patt));
    } catch (e) {
      // do nothing
      console.error(e);
    }
  }

  return _lines;
}

const moveOtherNameLast = (obj : any) => {
  const _idx = findIndex(obj, { name : 'Others'});
  
  if (! (_idx  > -1)) return;

  const _other = cloneDeep(obj[_idx]);
  obj.splice(_idx, 1);
  obj.push(_other);
}

export { getAssignees, checkForSearchMatch, applyFormSearchFilter, moveOtherNameLast }
